import { render } from "./WizardTransporteur.vue?vue&type=template&id=6add4e7e"
import script from "./WizardTransporteur.vue?vue&type=script&lang=js"
export * from "./WizardTransporteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__